// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__6jp8I","spin":"style_spin__qa6gZ"};